import {
  GET_PROJECT_STATUS
} from '../mutation-types'

const state = {
  all: []
}

const mutations = {
  [GET_PROJECT_STATUS] (state, data) {
    state.all = data
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/projectStatus.js